<template>
  <v-list-item>
    <v-list-item-content>
      <v-text-field
        v-model="content"
        v-bind="inputAttributes"
        @click:append="$emit('click:append')"
        v-on:keyup.enter="$emit('enter')"
        @input="handleInput"
      ></v-text-field>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: "DocumentText",
  props: ["value", "inputAttributes"],
  data() {
    return {
      content: this.value
    };
  },
  methods: {
    handleInput() {
      this.$emit("input", this.content);
    }
  }
};
</script>

<style></style>
